import { lazy } from 'react';

export const SettingsLazy = lazy(() => import('./Settings'));
